import { render, staticRenderFns } from "./RegisterDoctor.vue?vue&type=template&id=863459f0&"
import script from "./RegisterDoctor.vue?vue&type=script&lang=js&"
export * from "./RegisterDoctor.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDoctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports